import React from "react";
import { Request } from "../utils/Request";
import {
  APP,
  EXCEPTS,
  CORE,
  COOKIE,
  LINKS,
  BLOCKCHAIN,
  TYPESTATE,
  EXTERNALCOMPANY,
  USERGROUPS,
  FINANCE,
  ACCESSLEVELS,
  RESPONSE,
} from "./GlobalConstants";

class App {
  constructor(args) {
    this.Init(args);
    this.InitCore();
    this.InitClient();
    this.SetLanguage(args.language);
  }

  Init = (args) => {
    this.language = { name: "", code: "" };
    this.hooks = {};
    this.cookies = {
      instance: null,
    };
    this.views = {
      public: {
        statistics: {
          activeUsers: 0,
          totalFund: 0,
          totalCoins: 0,
        },
      },
    };
  };

  InitClient = () => {
    this.client = {
      ip: "",
      country: "",
      lat: 0,
      long: 0,
    };
    // const request = new Request(LINKS.API_GEOLOCATION, {}, false);
    // request.get("json/", null, (code, data) => {
    //   if (code === 200) {
    //     this.client.ip = data.IPv4;
    //     this.client.country = data.country_code;
    //     this.client.lat = data.latitude;
    //     this.client.long = data.longitude;
    //   }
    // });
  };

  InitCore = () => {
    this.core = {
      url: CORE.API_URL,
      access_token: CORE.API_ACCESS_TOKEN,
    };
  };

  InitPublic = () => {
    return true;
  };

  GetAppName = (isCommertial = false) => {
    switch (this.language.code) {
      case APP.LANG.FA.CODE:
        return isCommertial === true ? APP.NAME_COMMERTIAL.FA : APP.NAME.FA;

      default:
        return isCommertial === true ? APP.NAME_COMMERTIAL.FA : APP.NAME.FA;
    }
  };

  SetLanguage = (code) => {
    if (code === "fa") {
      this.language.code = APP.LANG.FA.CODE;
      this.language.name = APP.LANG.FA.NAME;
    }
    return true;
  };

  GetLanguage = () => {
    return this.language;
  };
}

class Authentication {
  constructor(args) {
    this.InitCore();
    this.InitUser();
  }

  InitUser = () => {
    this.user = {
      access_token: null,
      hasCookie: false,
      validToken: null,
      permissions: [],
    };
  };

  InitCore = () => {
    this.app = {
      validToken: null,
    };
  };

  DestructUser = () => {
    AppConfig.cookies.instance[2](COOKIE.COR.U, { path: "/" });
    setTimeout(() => {
      this.user.access_token = null;
      this.user.hasAccess = false;
      this.user.hasCookie = false;
      this.user.validToken = null;
      AppConfig.hooks.useHistory.push(LINKS.APP.MAIN);
    }, 100);
  };

  AuthenticateUser = () => {
    try {
      this.user.access_token = AppConfig.cookies.instance[0][COOKIE.COR.U];
      if (!this.user.access_token) throw new Error(EXCEPTS.NOT_VALID_COOKIE);
      this.user.hasCookie = true;
      const request = new Request();
      request.post(
        LINKS.CORE.USER.AUTHENTICATE_ACCESSTOKEN,
        null,
        (code, data) => {
          if (data && "code" in data && data.code === RESPONSE.CODE.SUCCESS) {
            this.user.validToken = true;
            this.user.hasAccess = true;
            return true;
          }
          this.DestructUser();
        },
        (data) => {
          this.DestructUser();
        }
      );
    } catch (ex) {}
  };
}

class SecurityUtil {
  validateName(name) {
    return /^([A-Za-zا-ی\s]){2,500}$/.test(name);
  }

  validateUsername(username) {
    return /^([A-Za-z0-9_.]){3,500}$/.test(username);
  }

  validateEmail(email) {
    return /^[a-zA-Z0-9-_.]+@[a-zA-Z0-9-_]+\.[A-Za-z]+$/.test(email);
  }

  validateMobileNumber(phone, unicode = false) {
    return unicode === true
      ? /^(09|0۹|۰9|۰۹)[0-9۰-۹]{9}.*$/.test(phone)
      : /^09[0-9]{9}.*$/.test(phone);
  }

  validateTelNumber(phone, unicode = false) {
    return unicode === true
      ? /^(0|۰|\+)[0-9۰-۹]{9}.*$/.test(phone)
      : /^(0|\+)[0-9]{9}.*$/.test(phone);
  }

  validateCode(code, unicode = false, length = 0) {
    const regex = new RegExp(
      `^[0-9${unicode === true && "۰-۹"}]${length > 0 && `{${length}}`}.*$`
    );
    return regex.test(code);
  }

  validateNationalID(code, unicode = true, length = 10) {
    const regex = new RegExp(
      `^[0-9${unicode === true && "۰-۹"}]${`{${length}}`}.*$`
    );
    return regex.test(code);
  }

  validatePostalCode(code, unicode = true, length = 15) {
    const regex = new RegExp(
      `^[0-9${unicode === true && "۰-۹"}]${`{${length}}`}.*$`
    );
    return regex.test(code);
  }

  validatePassword(password, minLength = 0, maxLength = 500) {
    if (password !== null) {
      return minLength < password.length && password.length < maxLength;
    }
    return false;
  }
}

class BlockchainUtil {
  constructor() {}

  getActiveToken = () => {
    return BLOCKCHAIN.TOKENS.SYMBOL.IRANIAN_TOMANS;
  };

  getTokenPersian = (symbol, name = null) => {
    if (symbol in BLOCKCHAIN.TOKENS.FA) return BLOCKCHAIN.TOKENS.FA[symbol];
    else return name ? name : symbol;
  };

  convertFromBTC = (value, pairRate) => {
    return value * pairRate;
  };

  getTransactionTypePersian = (type, name = null) => {
    if (type.toUpperCase() in TYPESTATE.TX.FA)
      return TYPESTATE.TX.FA[type.toUpperCase()];
    else return name ? name : type;
  };
}

class GeneralUtil {
  constructor() {}

  getIranianBanksName = (card_pin, dash_styled = false) => {
    const FoundBank = Object.keys(EXTERNALCOMPANY.IRANIANBANKS).find(
      (key) => EXTERNALCOMPANY.IRANIANBANKS[key] === card_pin.substring(0, 6)
    );
    let CardPan = "";
    if (dash_styled === true) {
      CardPan = (
        <>
          {card_pin.substring(0, 4)}
          <small>-</small>
          {card_pin.substring(4, 8)}
          <small>-</small>
          {card_pin.substring(8, 12)}
          <small>-</small>
          {card_pin.substring(12, 16)}
        </>
      );
    } else {
      CardPan = `${card_pin.substring(0, 4)}-${card_pin.substring(
        4,
        8
      )}-${card_pin.substring(8, 12)}-${card_pin.substring(12, 16)}`;
    }
    return [FoundBank, CardPan];
  };

  getIranianBanksNamePersian = (enname, name = null) => {
    if (!enname) return "نامشخص";
    if (enname.toUpperCase() in EXTERNALCOMPANY.IRANIANBANKS.NAMES.FA)
      return EXTERNALCOMPANY.IRANIANBANKS.NAMES.FA[enname.toUpperCase()];
    else return name ? name : enname;
  };

  getFinanceAccountTypesPersian = (type, name = null) => {
    if (type.toUpperCase().replaceAll(" ", "") in FINANCE.ACCOUNT.FA)
      return FINANCE.ACCOUNT.FA[type.toUpperCase().replaceAll(" ", "")];
    else return name ? name : type;
  };

  getUsergroupPersian = (usergroup, name = null) => {
    if (usergroup.toUpperCase() in USERGROUPS.FA)
      return USERGROUPS.FA[usergroup.toUpperCase()];
    else return name ? name : usergroup;
  };

  getAccessLevelPersian = (accessLevel, name = null) => {
    if (accessLevel.toUpperCase() in ACCESSLEVELS.FA)
      return ACCESSLEVELS.FA[accessLevel.toUpperCase()];
    else return name ? name : accessLevel;
  };

  getTicketSubjectPersian = (subject, name = null) => {
    if (subject.replace(" ", "").toUpperCase() in TYPESTATE.TICKET.FA)
      return TYPESTATE.TICKET.FA[subject.replace(" ", "").toUpperCase()];
    else return name ? name : subject;
  };

  getStateTicketPersian = (
    state,
    is_resolved = false,
    is_answered = false,
    name = null
  ) => {
    if (is_resolved === true) return TYPESTATE.TICKET.FA.CLOSED;
    else if (is_answered === true) return TYPESTATE.TICKET.FA.ANSWERED;
    else if (state.replace(" ", "").toUpperCase() in TYPESTATE.STATE.FA)
      return TYPESTATE.STATE.FA[state.replace(" ", "").toUpperCase()];
    else return name ? name : state;
  };

  getStatePersian = (state, name = null) => {
    if (state.replace(" ", "").toUpperCase() in TYPESTATE.STATE.FA)
      return TYPESTATE.STATE.FA[state.replace(" ", "").toUpperCase()];
    else return name ? name : state;
  };

  formatMobileNumber = (mobile_number) => {
    return !mobile_number.startsWith("+")
      ? `+98${mobile_number.substring(1)}`
      : mobile_number;
  };
}

export const AppConfig = new App({ language: "fa" });
export const AuthConfig = new Authentication();
export const SecurityUtils = new SecurityUtil();
export const BlockchainUtils = new BlockchainUtil();
export const GeneralUtils = new GeneralUtil();
